export default "Time is now 17:23 UTC\nOn the return flight the pilot announces \"Low Oil Pressure / Low ENG Oil\"\nShip is encoutering banks of fog.";